import { Controller } from "@hotwired/stimulus"
import SignaturePad from "signature_pad"

export default class extends Controller {
  static targets = [
    "canvas", "clearButton", "displayName", "input", "modal", "name",
    "nameError", "preview", "resignButton", "signedName", "signedSummary",
    "unsignedSummary"
  ]
  static values = { defaultName: String }

  connect() {
    this.signaturePad = new SignaturePad(this.canvasTarget, {
      backgroundColor: "rgb(255, 255, 255)",
      penColor: "rgb(0, 0, 0)"
    })

    this._resizeHandler = this.resizeCanvas.bind(this)
    this._shownHandler = this.resizeCanvas.bind(this)
    this._hiddenHandler = this.resetDraft.bind(this)
    window.addEventListener("resize", this._resizeHandler)
    this.modal = window.jQuery(this.modalTarget)
    this.modal.on("shown.bs.modal", this._shownHandler)
    this.modal.on("hidden.bs.modal", this._hiddenHandler)
    this.resetDraft()
  }

  disconnect() {
    window.removeEventListener("resize", this._resizeHandler)
    this.modal.off("shown.bs.modal", this._shownHandler)
    this.modal.off("hidden.bs.modal", this._hiddenHandler)
    this.signaturePad.off()
  }

  clear() {
    this.signaturePad.clear()
  }

  resign() {
    this.previewTarget.classList.add("hidden")
    this.canvasTarget.classList.remove("hidden")
    this.clearButtonTarget.classList.remove("hidden")
    this.resignButtonTarget.classList.add("hidden")
    this.resizeCanvas()
  }

  adopt() {
    const name = this.nameTarget.value.trim()
    if (!name) {
      this.nameTarget.setAttribute("aria-invalid", "true")
      this.nameErrorTarget.classList.remove("hidden")
      this.nameTarget.focus()
      return
    }

    if (!this.signaturePad.isEmpty()) {
      const image = this.signaturePad.toDataURL("image/png")
      this.inputTarget.value = image
      this.previewTarget.src = image
    }

    this.signedNameTarget.value = name
    this.displayNameTarget.textContent = name
    this.unsignedSummaryTarget.classList.add("hidden")
    this.signedSummaryTarget.classList.remove("hidden")
    this.modal.modal("hide")
  }

  nameChanged() {
    if (!this.nameTarget.value.trim()) return

    this.nameTarget.removeAttribute("aria-invalid")
    this.nameErrorTarget.classList.add("hidden")
  }

  resizeCanvas() {
    const canvas = this.canvasTarget
    if (canvas.classList.contains("hidden")) return

    const ratio = Math.max(window.devicePixelRatio || 1, 1)
    const width = canvas.offsetWidth
    const pixelWidth = width * ratio
    if (!width || this.canvasWidth === pixelWidth) return

    const data = this.signaturePad.toData()

    canvas.width = pixelWidth
    canvas.height = 200 * ratio
    canvas.style.height = "200px"
    this.canvasWidth = pixelWidth

    canvas.getContext("2d").scale(ratio, ratio)
    this.signaturePad.clear()
    if (data.length) this.signaturePad.fromData(data)
  }

  resetDraft() {
    this.signaturePad.clear()
    this.nameTarget.value = this.signedNameTarget.value || this.defaultNameValue
    this.nameTarget.removeAttribute("aria-invalid")
    this.nameErrorTarget.classList.add("hidden")

    if (this.previewTarget.getAttribute("src")) {
      this.previewTarget.classList.remove("hidden")
      this.canvasTarget.classList.add("hidden")
      this.clearButtonTarget.classList.add("hidden")
      this.resignButtonTarget.classList.remove("hidden")
    } else {
      this.previewTarget.classList.add("hidden")
      this.canvasTarget.classList.remove("hidden")
      this.clearButtonTarget.classList.remove("hidden")
      this.resignButtonTarget.classList.add("hidden")
    }
  }
}
